module.exports = __webpack_public_path__ + "img/resumeprofile.51b17dc1.svg";